// extracted by mini-css-extract-plugin
export default {"container":"ProjectImgs_container__MLpwF","bgblock":"ProjectImgs_bgblock__OHpBJ"};